<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<el-col :span="6">
				<el-input clearable placeholder="请输入城市" v-model="searchInfo.cityname">
					<template slot="prepend">城市</template>
				</el-input>
			</el-col>
			<el-col :span="6">
				<el-input clearable placeholder="请输入控制器ID" v-model="searchInfo.controllerid">
					<template slot="prepend">控制器ID</template>
				</el-input>
			</el-col>
			<el-col :span="6">
				<el-input clearable placeholder="请输入校区" v-model="searchInfo.orgname">
					<template slot="prepend">校区</template>
				</el-input>
			</el-col>
			<el-col :span="6">
				<div style="min-width: 400px;">
					<el-button type="primary" @click="searchRecharge" icon="el-icon-search">搜索</el-button>
					<el-button icon="el-icon-refresh" @click="clearSearch">重置</el-button>
					<el-button type="primary" @click="asyncRecharge" icon="el-icon-search">同步</el-button>
				</div>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-table :data="rechargeList" style="width: 100%" max-height="700">
				<el-table-column prop="cityname" label="城市" width="120" align="center"></el-table-column>
				<el-table-column prop="orgname" label="校区" width="180" align="center"></el-table-column>
				<el-table-column prop="controllerid" label="控制器ID" width="180" align="center"></el-table-column>
				<el-table-column prop="chargeTime" label="充值时间" align="center"></el-table-column>
				<el-table-column prop="limitTime" label="到期时间" align="center">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.limitTime && scope.row.limitTime <= currentdate" type="danger">{{ scope.row.limitTime }}</el-tag>
						<span v-else >{{ scope.row.limitTime }}</span>
					</template>
				</el-table-column>
				<el-table-column fixed="right" prop="op" label="操作" width="180" align="center">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="editRecharge(scope.$index, scope.row)">编辑</el-button>
						<el-button type="text" size="small" style="color: #F56C6C;" @click="deleteRecharge(scope.$index, scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center; margin-top: 10px;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]"
				:current-page="param.page" :page-size="param.pagesize" :total="total" @size-change="handleSizeChange"
				@current-change="handleCurrentChange"> </el-pagination>
		</div>

		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
			<el-form :model="form" label-width="100px">
				<el-form-item label="城市">
					<el-input disabled v-model="form.cityname" placeholder="请输入城市"></el-input>
				</el-form-item>
				<el-form-item label="校区">
					<el-input disabled v-model="form.orgname" placeholder="校区"></el-input>
				</el-form-item>
				<el-form-item label="控制器ID">
					<el-input disabled v-model="form.controllerid" placeholder="请输入控制器ID"></el-input>
				</el-form-item>
				<el-form-item label="充值时间">
					<el-date-picker v-model="form.chargeTime" type="date" placeholder="选择日期" style="width: 100%;">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="到期时间">
					<el-date-picker v-model="form.limitTime" type="date" placeholder="选择日期" style="width: 100%;">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="备注">
					<el-input type="textarea" v-model="form.remark" placeholder="请输入备注"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="saveRecharge">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import dayjs from 'dayjs'
import {
	queryControllerRechargeRecords,
	editControllerRechargeRecords,
	deleteControllerRechargeRecords,
	asyncControllerRecord,
} from '/static/apiUrl.js'

export default {
	name: 'RechargeList',
	data() {
		return {
			searchInfo: {
				cityname: '',
				controllerid: '',
				orgname: '',
			},
			currentdate:'',
			orgList: [],
			param: {
				page: 1,
				pagesize: 10,
			},
			total: 0,
			rechargeList: [],
			dialogVisible: false,
			dialogTitle: '编辑充值记录',
			form: {
				id: '',
				cityname: '',
				orgname: '',
				controllerid: '',
				chargeTime: '',
				limitTime: '',
				remark: '',
			},
			isEdit: false,
		}
	},
	mounted() {
		let currentDate = new Date();
		// 设置为上月的日期
		currentDate.setMonth(currentDate.getMonth() - 1);
		this.currentdate = dayjs(currentDate).format('YYYY-MM-DD')
		console.log(this.currentdate)
		this.initData()
		this.queryRechargeList()
	},
	methods: {
		handleSizeChange(val) {
			this.param.pagesize = val
			this.queryRechargeList()
		},
		handleCurrentChange(val) {
			this.param.page = val
			this.queryRechargeList()
		},
		initData() {
			
		},
		searchRecharge() {
			this.param.page = 1
			this.queryRechargeList()
		},
		clearSearch() {
			this.searchInfo.cityname = ''
			this.searchInfo.controllerid = ''
			this.searchInfo.orgname = ''
			this.param.page = 1
			this.queryRechargeList()
		},
		queryRechargeList() {
			this.rechargeList = []
			queryControllerRechargeRecords({
				cityname: this.searchInfo.cityname,
				controllerid: this.searchInfo.controllerid,
				orgname: this.searchInfo.orgname,
				pagenum: this.param.page,
				pagesize: this.param.pagesize
			}).then(res => {
				if (0 == res.code) {
					this.total = res.datas.totalnum
					res.datas.data.forEach((item) => {
						this.rechargeList.push({
							id: item.id,
							cityname: item.cityname,
							orgname: item.orgname,
							controllerid: item.controllerid,
							chargeTime: item.chargeTime ? dayjs(item.chargeTime).format('YYYY-MM-DD') : '',
							limitTime: item.limitTime ? dayjs(item.limitTime).format('YYYY-MM-DD') : '',
							remark: item.remark
						})
					})
				}
			})
		},
		editRecharge(index, row) {
			this.isEdit = true
			this.dialogTitle = '编辑充值记录'
			this.form = {
				id: row.id,
				cityname: row.cityname,
				orgname: row.orgname,
				controllerid: row.controllerid,
				chargeTime: row.chargeTime,
				remark: row.remark
			}
			this.dialogVisible = true
		},
		deleteRecharge(index, row) {
			this.$confirm('确定删除该记录吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				deleteControllerRechargeRecords({
					id: row.id
				}).then(res => {
					if (0 == res.code) {
						this.$message({
							showClose: true,
							message: '删除成功',
							type: 'success'
						})
						this.queryRechargeList()
					} else {
						this.$message({
							showClose: true,
							message: res.message,
							type: 'error'
						})
					}
				})
			}).catch(() => {
				console.log('取消删除')
			})
		},
		asyncRecharge(){
			asyncControllerRecord().then(res => {
				if (0 == res.code) {
					this.$message({
						showClose: true,
						message: '同步成功',
						type: 'success'
					})
					this.queryRechargeList()
				} else {
					this.$message({
						showClose: true,
						message: res.message,
						type: 'error'
					})
				}
			})
		},
		saveRecharge() {
			if (!this.form.cityname) {
				this.$message({
					showClose: true,
					message: '请选择城市',
					type: 'warning'
				})
				return
			}
			if (!this.form.controllerid) {
				this.$message({
					showClose: true,
					message: '请输入控制器名称',
					type: 'warning'
				})
				return
			}

			const params = {
				id: this.form.id,
				cityname: this.form.cityname,
				orgname: this.form.orgname,
				controllerid: this.form.controllerid,
				chargeTime: this.form.chargeTime ? dayjs(this.form.chargeTime).format('YYYY-MM-DD') : '',
				limitTime: this.form.limitTime ? dayjs(this.form.limitTime).format('YYYY-MM-DD') : '',
				remark: this.form.remark
			}

			editControllerRechargeRecords(params).then(res => {
				if (0 == res.code) {
					this.$message({
						showClose: true,
						message: '保存成功',
						type: 'success'
					})
					this.dialogVisible = false
					this.queryRechargeList()
				} else {
					this.$message({
						showClose: true,
						message: res.message,
						type: 'error'
					})
				}
			})
		},
	},
	beforeDestroy() {

	},
}
</script>

<style scoped>

</style>
